module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "单据统计-餐企"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    attrs: {
      "id": "common-scroll"
    },
    on: {
      "scroll": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "billcount-filter",
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui-date-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "bill-filter-date",
    attrs: {
      "type": "date",
      "placeholder": "开始日期"
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#eee",
      "float": "left",
      "margin": "0px 5px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "bill-filter-date",
    attrs: {
      "type": "date",
      "placeholder": "结束日期"
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "billcount-search",
    on: {
      "click": _vm.billSearch
    }
  }, [_vm._v("查询")])]), _vm._v(" "), _c('a', {
    staticClass: "ui-filter-icon",
    on: {
      "click": _vm.move
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('ul', {
    staticClass: "ui-listview"
  }, _vm._l((_vm.billCounts), function(billCount) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/bill-count-detail',
          query: {
            restaurant_id: billCount.organ_id,
            bill_state: _vm.queryData.bill_state,
            start_date: _vm.queryData.start_date,
            end_date: _vm.queryData.end_date,
            restaurant_name: billCount.organ_name
          }
        }
      }
    }, [_c('p', {
      staticClass: "allorderbill-list-p"
    }, [_vm._v(_vm._s(billCount.organ_name))]), _vm._v(" "), _c('ul', {
      staticClass: "ui-detail-listview ui-billcount-detail-listview"
    }, [_c('li', [_vm._v("订货金额：" + _vm._s(billCount.order_bill_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收金额: " + _vm._s(billCount.sum_money_recipient) + "元")]), _vm._v(" "), _c('li', [_vm._v("订货单：共" + _vm._s(billCount.order_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("发货金额：" + _vm._s(billCount.deliver_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("退货单：共" + _vm._s(billCount.reverse_bill_num) + "张")]), _vm._v(" "), _c('li', [_vm._v("退货金额：" + _vm._s(billCount.reverse_money) + "元")]), _vm._v(" "), _c('li', [_vm._v("发货减实收：" + _vm._s(_vm._f("filterFloat")((billCount.deliver_money - billCount.sum_money_recipient))) + " 元")]), _vm._v(" "), _c('li', [_vm._v("实收减退货：" + _vm._s(_vm._f("filterFloat")((billCount.sum_money_recipient - billCount.reverse_money))) + "元")])])])], 1)
  }), 0)]), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('get-total', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    ref: "cTotal",
    attrs: {
      "filter": _vm.filterData,
      "href": "/cldEdi/business/getTotal",
      "name": "餐企"
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('bill-filter', {
    ref: "billFilterOpen",
    attrs: {
      "filterBillState": _vm.queryData.bill_state,
      "filterRestaurantId": _vm.queryData.restaurant_id,
      "filterRestaurantName": _vm.restaurantName
    },
    on: {
      "printData": _vm.getBackValue,
      "open": _vm.onFilterOpen
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d674703!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BillCount.vue
// module id = 598
// module chunks = 1